<script >
import {defineComponent} from "vue";

export default defineComponent({
  name: 'back-icon',
  methods:{
    showSearch(){
      return history.back();
    }
  }
});
</script>

<template>
  <div class="col-1 float-left search" @click="showSearch">
    <i class="fa-solid fa-arrow-left"></i>
  </div>
</template>

<style scoped>
.search{
  text-align: center;
  margin-top: 5px;
}
.search i{
  font-size: 12pt !important;
  color: #1fa29d;
  margin-right: 7px;
  //margin-top: 5px;
}
a{
  color: #1fa29d;
  text-decoration: none;
}
a:hover{
  color: #005956;
}
</style>